import { render, staticRenderFns } from "./zesa.vue?vue&type=template&id=45c056d6"
import script from "./zesa.vue?vue&type=script&lang=js"
export * from "./zesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports